import { SettingsTab } from '../../../types';
import {
  OR_CHANGE_SETTINGS_TAB,
} from '../../../actions/management/orSettings';

export const initialState = SettingsTab.HOLIDAYS;

export default function activeTabReducer(state = initialState, action) {
  switch (action.type) {
    case OR_CHANGE_SETTINGS_TAB:
      return action.activeTab;
    default:
      return state;
  }
}
